import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getPositionDevices(options = {}) {
	return _apiRequestWrap(
		ModulesMap.POSITION_DEVICES,
		ModulesConfigMap[ModulesMap.POSITION_DEVICES].GET_POSITION_DEVICES,
		options
	)
}

function _getPositionDevice(options = {}) {
	return _apiRequestWrap(
		ModulesMap.POSITION_DEVICES,
		ModulesConfigMap[ModulesMap.POSITION_DEVICES].GET_POSITION_DEVICE,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.POSITION_DEVICES].GET_POSITION_DEVICES]: _getPositionDevices,

	[ModulesConfigMap[ModulesMap.POSITION_DEVICES].GET_POSITION_DEVICE]: _getPositionDevice,
}
